import { getLocalStorage, setLocalStorage } from '../src/utils/storage'

function getJewelTagsFocus() {
  return getLocalStorage('JEWEL_TAGS_FOCUS')
}

function setJewelTagsFocus(tags) {
  setLocalStorage('JEWEL_TAGS_FOCUS', tags)
}

let jewelTags = {
  'school-pair': {
    title: '珠宝搭配', type: 'school-pair', children: [
      { name: '珠宝搭配', thumbnail: 'http://img.tutubox.cn/school-1.png' },
      { name: '真假鉴定', thumbnail: 'http://img.tutubox.cn/school-2.png' },
      { name: '保养大全', thumbnail: 'http://img.tutubox.cn/school-3.png' }
    ]
  },
  'school-gemstone': {
    title: '天然宝石', name: 'school-gemstone', children: [
      { name: '钻石', thumbnail: 'http://img.tutubox.cn/school-5.png' },
      { name: '祖母绿', thumbnail: 'http://img.tutubox.cn/school-6.png' },
      { name: '蓝宝石', thumbnail: 'http://img.tutubox.cn/school-7.png' },
      { name: '红宝石', thumbnail: 'http://img.tutubox.cn/school-8.png' },
      { name: '猫眼石', thumbnail: 'http://img.tutubox.cn/school-10.png' },
      { name: '欧珀石', thumbnail: 'http://img.tutubox.cn/school-11.png' },
      { name: '碧玺', thumbnail: 'http://img.tutubox.cn/school-12.png' },
      { name: '水晶', thumbnail: 'http://img.tutubox.cn/school-13.png' },
      { name: '石榴石', thumbnail: 'http://img.tutubox.cn/school-14.png' },
      { name: '橄榄石', thumbnail: 'http://img.tutubox.cn/school-15.png' },
      { name: '红纹石', thumbnail: 'http://img.tutubox.cn/school-16.png' },
      { name: '坦桑石', thumbnail: 'http://img.tutubox.cn/school-17.png' },
      { name: '托帕石', thumbnail: 'http://img.tutubox.cn/school-18.png' },
      { name: '尖晶石', thumbnail: 'http://img.tutubox.cn/school-19.png' },
      { name: '摩根石', thumbnail: 'http://img.tutubox.cn/school-20.png' },
      { name: '天河石', thumbnail: 'http://img.tutubox.cn/school-21.png' },
      { name: '青金石', thumbnail: 'http://img.tutubox.cn/school-23.png' },
      { name: '东陵石', thumbnail: 'http://img.tutubox.cn/school-24.png' },
      { name: '虎晴石', thumbnail: 'http://img.tutubox.cn/school-25.png' },
      // { name: '芙蓉石', thumbnail: 'http://img.tutubox.cn/school-26.png' },
      { name: '绿松石', thumbnail: 'http://img.tutubox.cn/school-27.png' },
      // { name: '青田石', thumbnail: 'http://img.tutubox.cn/school-28.png' },
      { name: '孔雀石', thumbnail: 'http://img.tutubox.cn/school-29.png' },
      // { name: '黑曜石', thumbnail: 'http://img.tutubox.cn/school-30.png' },
      { name: '田黄石', thumbnail: 'http://img.tutubox.cn/school-31.png' }
    ]
  },
  'school-jade': {
    title: '天然玉石', type: 'school-jade', children: [
      { name: '和田玉', thumbnail: 'http://img.tutubox.cn/school-32.png' },
      { name: '翡翠', thumbnail: 'http://img.tutubox.cn/school-33.png' },
      { name: '金丝玉', thumbnail: 'http://img.tutubox.cn/school-34.png' },
      { name: '蓝田玉', thumbnail: 'http://img.tutubox.cn/school-35.png' },
      { name: '南红', thumbnail: 'http://img.tutubox.cn/school-40.png' },
      { name: '玛瑙', thumbnail: 'http://img.tutubox.cn/school-41.png' },
      { name: '昆仑玉', thumbnail: 'http://img.tutubox.cn/school-42.png' },
      { name: '岫岩玉', thumbnail: 'http://img.tutubox.cn/school-43.png' },
      { name: '黄龙玉', thumbnail: 'http://img.tutubox.cn/school-44.png' },
      { name: '独山玉', thumbnail: 'http://img.tutubox.cn/school-45.png' },
      // { name: '玉髓', thumbnail: 'http://img.tutubox.cn/school-46.png' }
    ]
  },
  'school-jade-organic': {
    title: '有机宝石', type: 'school-jade-organic', children: [
      { name: '珍珠', thumbnail: 'http://img.tutubox.cn/school-47.png' },
      { name: '琥珀', thumbnail: 'http://img.tutubox.cn/school-48.png' },
      { name: '蜜蜡', thumbnail: 'http://img.tutubox.cn/school-49.png' },
      { name: '红珊瑚', thumbnail: 'http://img.tutubox.cn/school-50.png' },
      // { name: '砗磲', thumbnail: 'http://img.tutubox.cn/school-51.png' },
      { name: '煤玉', thumbnail: 'http://img.tutubox.cn/school-52.png' }
    ]
  },
  'school-noble-metal': {
    title: '贵金属', type: 'school-noble-metal', children: [
      { name: '黄金', thumbnail: 'http://img.tutubox.cn/school-53.png' },
      { name: '铂金', thumbnail: 'http://img.tutubox.cn/school-54.png' },
      { name: '白银', thumbnail: 'http://img.tutubox.cn/school-55.png' },
      { name: 'K金', thumbnail: 'http://img.tutubox.cn/school-56.png' }
    ]
  },
  'school-collection': {
    title: '文玩收藏', type: 'school-collection', children: [
      { name: '菩提', thumbnail: 'http://img.tutubox.cn/school-57.png' },
      { name: '檀木', thumbnail: 'http://img.tutubox.cn/school-58.png' },
      { name: '瓷器', thumbnail: 'http://img.tutubox.cn/school-59.png' },
      { name: '崖柏', thumbnail: 'http://img.tutubox.cn/school-60.png' },
      // { name: '红木', thumbnail: 'http://img.tutubox.cn/school-61.png' },
      { name: '核桃', thumbnail: 'http://img.tutubox.cn/school-62.png' },
      // { name: '唐卡', thumbnail: 'http://img.tutubox.cn/school-63.png' }
    ]
  }
}

let jewelTagsRecommend = [
    { name: '珠宝搭配', thumbnail: 'http://img.tutubox.cn/school-1.png' },
    { name: '黄金', thumbnail: 'http://img.tutubox.cn/school-53.png' },
    { name: '珍珠', thumbnail: 'http://img.tutubox.cn/school-47.png' },
    { name: '钻石', thumbnail: 'http://img.tutubox.cn/school-5.png' },
]

let jewelTagsFocus = getJewelTagsFocus() || {}

Object.entries(jewelTags).forEach(([type, group]) => {
  let groupFocus = jewelTagsFocus[type]

  group.children.forEach(item => {
    item.checked = (groupFocus || []).some(itemFocus => {
      return itemFocus.name === item.name
    })
  })

  if(!groupFocus || groupFocus.length === 0) {
    jewelTagsFocus[type] = group.children.slice(0, 4)
  }
})

export {
  jewelTags,
  jewelTagsFocus,
  jewelTagsRecommend,
  getJewelTagsFocus,
  setJewelTagsFocus
}